<template>
  <v-app>
    <v-container
      fluid
      tag="section"
      class="pt-0"
    >
      <v-row justify="center">
        <v-col
          cols="12 px-6"
        >
          <v-row>
            <v-col class="py-0">
              <v-img
                contain
                src="logo.png"
                height="4rem"
                width="8rem"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0 text-center">
              <span :style="`color:${finalScreen.text1.color};font-size:${finalScreen.text1.size}px`">{{ finalScreen.text1.text }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0 text-center">
              <span :style="`color:${finalScreen.text2.color};font-size:${finalScreen.text2.size}px`">{{ finalScreen.text2.text }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0 text-center">
              <span :style="`color:${finalScreen.text3.color};font-size:${finalScreen.text3.size}px`">{{ finalScreen.text3.text }}</span>
            </v-col>
          </v-row>
          <v-card
            flat
            height="12rem"
            class="d-flex align-center justify-center"
          >
            <v-icon
              size="8rem"
              color="green"
            >
              mdi-check-circle-outline
            </v-icon>
          </v-card>
          <v-row>
            <v-col
              cols="12"
              class="text-center payment-message pa-1"
            >
              Оплата успешна
            </v-col>
            <v-col class="text-center payment-message2 pa-1">
              {{ Number(this.payment.sum).money() }}
            </v-col>
          </v-row>
          <!--          <v-row>-->
          <!--            <v-col>-->
          <!--              <v-text-field-->
          <!--                v-model="email"-->
          <!--                dense-->
          <!--                hide-details-->
          <!--                outlined-->
          <!--                label="Введите свой e-mail"-->
          <!--              />-->
          <!--            </v-col>-->
          <!--          </v-row>-->
          <!--          <v-row>-->
          <!--            <v-col cols="12">-->
          <!--              <v-btn-->
          <!--                width="100%"-->
          <!--                depressed-->
          <!--                @click="onSendCheque"-->
          <!--              >-->
          <!--                Отправить чек-->
          <!--              </v-btn>-->
          <!--            </v-col>-->
          <!--          </v-row>-->
          <!--          <v-row>-->
          <!--            <v-col-->
          <!--              v-if="showMessage"-->
          <!--              cols="12"-->
          <!--              class="text-center py-1"-->
          <!--            >-->
          <!--              {{ this.message }}-->
          <!--            </v-col>-->
          <!--          </v-row>-->
          <v-row>
            <v-col cols="12">
              <v-btn
                color="black"
                outlined
                width="100%"
                @click="onGetCheque"
              >
                Чек платежа
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                color="info"
                width="100%"
                outlined
                @click="onReturn"
              >
                На главную
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<style scoped>
.payment-message {
  font-size: 1.5rem;
  font-weight: 400;
}
.payment-message2 {
  font-size: 2rem;
  font-weight: 700;
}
</style>
<script>
// import { JustpayOrderModel } from "@/views/loyalty/models/justpay-order.model"
import { JustpayPaymentSystemService } from "@/views/loyalty/shared/services/justpay-paymentsystem-service"

export default {
  data: () => ({
    email: null,
    finalScreen: {
      text1: {
        text: "",
        color: "#000000",
        size: 0
      },
      text2: {
        text: "",
        color: "#000000",
        size: 0
      },
      text3: {
        text: "",
        color: "#000000",
        size: 0
      },
    },
    message: '',
    // order: new JustpayOrderModel(),
    payment: {
      sum: 0
    },
    showMessage: false
  }),
  async beforeMount () {
    const orderNumber = this.$route.query.reference // it is idempotency
    this.justpayPaymentSystemService = new JustpayPaymentSystemService()
    const response = await this.justpayPaymentSystemService.getPaymentByIdempotency(orderNumber)
    console.log('response', response)
    if (!response.value.error) {
      this.payment = response.value.data.payment
      this.finalScreen = response.value.data.finalScreen
    } else {
      // await this.$router.push('/paymentsystemfailure')
      window.open('paymentsystemfailure', '_self')
    }
    // this.order = new JustpayOrderModel(order)
  },
  methods: {
    onGetCheque () {
      window.open(`cheque?id=${this.payment.id}`, '_blank')
    },
    onReturn () {
      const pointId = localStorage.getItem('pointId')
      console.log(pointId)
      if (pointId) { this.$router.push('/paymentsystem?id=' + pointId) }
    },
    // async onSendCheque () {
    //   if (this.email) {
    //     // this.message = await this.justpayQrPaymentService.sendCheque(this.order.orderId, this.email)
    //     this.showMessage = true
    //     setTimeout(() => { this.showMessage = false }, 5000)
    //   }
    // }
  }
}
</script>
